export default {
  th: {
    category: 'หมวดหมู่',
  },
  en: {
    category: 'category',
  },
  zh: {
    category: 'category',
  },
}
